export default "__VITE_ASSET__DMPWfSp___"